import styled from 'styled-components';

export const SwitchGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: auto;
`;

export const ParentContainer = styled.div`
    display: inline-flex;
    flex-direction: row;
`;

export const CaptionContainer = styled.div`
    display: flex;
    margin-left: 54px;
`;
